import { memo } from 'react';
import { NodeProps } from 'reactflow';
import { BaseNode } from './BaseNode';

export const TextNode = memo((props: NodeProps) => {
  const getDescription = () => {
    const hasVariations = props.data.config?.useTextVariations;
    const variationsCount = props.data.config?.textVariations?.length || 0;

    if (hasVariations && variationsCount > 0) {
      return `${variationsCount} variation${variationsCount > 1 ? 's' : ''}`;
    }

    const content = props.data.config?.content;
    if (content) {
      return content.substring(0, 30) + (content.length > 30 ? '...' : '');
    }

    return 'Configure the message';
  };

  return (
    <BaseNode
      {...props}
      icon="📝"
      label="Text"
      color="#3ddc97"
      description={getDescription()}
      onDelete={props.data.onDelete}
    />
  );
});

TextNode.displayName = 'TextNode';
